import React, { useEffect, useState } from "react";
import { Paper, Typography, Grid, Box } from "@mui/material";
import SubmissionTable from "../components/SubmissionsTable/SubmissionTable";
import { useFormSubmissions } from "../contexts/FormSubmissionsContext";
import { useFormContext } from "../contexts/FormContext";

const SubmissionsPage = () => {
  const { formId, formIdReady, formDetails } = useFormContext();

  // Pull the scope switcher so the dedicated page can show ALL rows (not just viewer-only)
  const {
    submissions,
    fetchSubmissions,
    loading,
    error,
    setScope,               // ← NEW: lets the page declare “all rows” vs “only mine”
  } = useFormSubmissions();

  // ✅ Prevent multiple fetch calls with local state
  const [hasFetched, setHasFetched] = useState(false);
  const [loggedFormId, setLoggedFormId] = useState(null);

  // ✅ Reset hasFetched when navigating to a different form (prevents stale guards)
  useEffect(() => {
    if (!formIdReady) return;
    if (formId && formId !== loggedFormId) {
      // console.log("[SubmissionsPage] Detected formId change. Resetting fetch guard.");
      setHasFetched(false);
    }
  }, [formIdReady, formId, loggedFormId]);

  // ✅ Fetch submissions **only when formIdReady becomes true**
  //    ALSO declare that this page should show **ALL** submissions (not viewer-only)
useEffect(() => {
  if (!formIdReady || !formId || hasFetched) return;

  // Standalone page shows ALL rows and refetches immediately.
  setScope(false, { refetch: true });

  // OPTIONAL: if you ever want to override the default Last 7 Days:
  // setDateRange([new Date(2000, 0, 1), new Date()]); // “All time”

  setHasFetched(true);
}, [formIdReady, formId, hasFetched, setScope /*, setDateRange */]);


  // ✅ Log form details **only when formId changes**
  useEffect(() => {
    if (formId && formId !== loggedFormId) {
      // console.log("[SubmissionsPage] Current formId:", formId);
      // console.log("[SubmissionsPage] formIdReady:", formIdReady);
      // console.log("[SubmissionsPage] formDetails:", formDetails);
      setLoggedFormId(formId);
    }
  }, [formId, formIdReady, formDetails, loggedFormId]);

  // ✅ Log submissions **only after the first valid fetch**
  useEffect(() => {
    if (hasFetched && submissions.length > 0) {
      // console.log("[SubmissionsPage] Fetched Submissions:", submissions);
      // console.log("[SubmissionsPage] Passing submissions to SubmissionTable:", submissions);

      // 🟢 Add a structured log to check the exact submission format
      // console.log("[SubmissionsPage] Final submissions data sent to SubmissionTable:", 
      //   JSON.stringify(submissions, null, 2)
      // );

      // console.log("[SubmissionsPage] Loading State:", loading);
    }
  }, [submissions, loading, hasFetched]);

  if (!formIdReady) {
    // console.log("[SubmissionsPage] formId is not ready, waiting...");
    return null; //  Prevent rendering instead of showing "Loading form..."
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",  //  Recommended background color for better contrast
        padding: "12px 24px 24px 24px", //  Top padding set to 12px, others remain 24px
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ marginTop: "12px" }}> {/* Adds spacing from navbar */}
          {error ? (
            <Typography variant="body1" color="error">
              Error fetching submissions: {error}
            </Typography>
          ) : (
          <SubmissionTable
            thumbSize={40}
            data={submissions}
            loading={loading}
          />

          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubmissionsPage;
